import { promiseModal } from '@/components/commons/System/System';
import styles from './FlowPopup.module.scss';
import { FlowArrowBottom } from '@/components/Flow/FlowDetail';
import { FileImage, HoverUnderlineWrapper, Underline } from '@/components';
import { Collections } from '@/utils';
import { cx } from '@emotion/css';
import { useEffect } from 'react';
import Router from 'next/router';

const FlowPopup = ({ onClose, resolve, reject, collections, collection, openPopup, currentFloor, currentIndex, pointColor }) => {
  const prevCollection = Collections.prevCollection(collections.randomCollections, currentFloor, currentIndex);
  const nextCollection = Collections.nextCollection(collections.randomCollections, currentFloor, currentIndex);

  useEffect(() => {
    Router.events.on('routeChangeStart', onClose);
    return () => Router.events.off('routeChangeStart', onClose);
  }, [onClose]);

  const fillPointColor = () => {
    return {
      backgroundColor: pointColor,
    };
  };

  const closePopup = () => {
    onClose();
    return resolve({ confirm: true });
  };

  const onClickPrev = () => {
    onClose();
    const { collection, floor, index } = prevCollection;
    openPopup(floor, index, collection);
  };

  const onClickNext = () => {
    onClose();
    const { collection, floor, index } = nextCollection;
    openPopup(floor, index, collection);
  };

  const clickOutside = (event) => {
    if (event.target !== event.currentTarget) return;
    closePopup();
  };

  return (
    <div className={styles.dimmed} onClick={clickOutside}>
      <div className={styles.container}>
        <button className={styles.closeButton} onClick={closePopup} />
        <div className={styles.imageContainer} style={fillPointColor()}>
          <div className={styles.imageTitle}>
            <div className={cx(styles.imageWrapper, collection.toggle && styles.fixed)}>
              <FileImage className={styles.image} src={collection.image} alt={'collection'} />
              <div className={`${styles.deco} ${styles.deco1}`} style={fillPointColor()} />
            </div>
            <div className={styles.imageInformation}>
              <div className={styles.korTitle}>{collection.koCollectionName}</div>
              <div className={styles.date}>{collection.year}</div>
            </div>
          </div>
          <div className={`${styles.deco} ${styles.deco2}`} style={fillPointColor()} />
          <div className={`${styles.deco} ${styles.deco3}`} style={fillPointColor()} />
          {prevCollection && (
            <HoverUnderlineWrapper className={styles.prevButtonWrapper} isLink={true} underlineColor={'#fff'} height={'2'}>
              <Underline className={styles.prevButton} wrapperTag={'button'} onClick={onClickPrev}>
                / PREV
              </Underline>
            </HoverUnderlineWrapper>
          )}
        </div>
        <div className={styles.descriptionContainer} style={fillPointColor()}>
          <div className={styles.engTitle}>{collection.enCollectionName}</div>
          <div className={styles.location}>위치 {collection.floor}</div>
          <FlowArrowBottom className={styles.arrowBottom} fill={pointColor} />
          <div className={styles.description}>{collection.description}</div>
          {nextCollection && (
            <HoverUnderlineWrapper className={styles.nextButtonWrapper} isLink={true} underlineColor={'#fff'} height={'2'}>
              <Underline className={styles.nextButton} wrapperTag={'button'} onClick={onClickNext}>
                / NEXT
              </Underline>
            </HoverUnderlineWrapper>
          )}
        </div>
      </div>
    </div>
  );
};

const FlowPromiseModal = {
  open: (props) => promiseModal(FlowPopup, { props }),
};

export { FlowPromiseModal };
